module.exports = __webpack_public_path__ + "static/holland-logo-908ff9c89aef8a25956ff9d8033d2278.png";